import React, { useState } from "react";
import { BiBlock } from "react-icons/bi";
// import doctorImg from "../assets/images/specialist.jpg";
import styles from "./BlockUsersList.module.css";
import { FaCheck, FaTimes } from "react-icons/fa";
import Loading from "./Loading";
// import SideBar from "./SideBar";

const BlockUserList = ({ showData }) => {
  const [blockedUserId, setBlockedUserId] = useState(null);
  const handleApproval = (id, approve) => {
    console.log(id, approve);
  };

  if (!showData) {
    <Loading />;
  }

  return (
    <div>
      {showData &&
        showData.activeHcps.map((item) => (
          <div key={item.id} className={styles.parent_container}>
            <div className={styles.child_container}>
              <img
                src={item?.profileImage}
                alt="logo"
                className={styles.doctor_logo}
              />
              <div className={styles.name_speciality}>
                <p className={styles.user_name}>{item?.fullName}</p>
                <p className={styles.speciality} style={{ color: "#729cb2" }}>
                  {item?.speciality}
                </p>
              </div>
            </div>
            {blockedUserId === item.id && (
              <div className={styles.confirmationBox}>
                <p>Do you want to block this user?</p>
                <div>
                  <FaCheck
                    className={styles.confirmIcon}
                    color="green"
                    size={20}
                    onClick={() => handleApproval(item.id, 1)}
                  />
                  <FaTimes
                    className={styles.closeIcon}
                    color="red"
                    size={20}
                    onClick={() => setBlockedUserId(null)}
                  />
                </div>
              </div>
            )}
            <div>
              <BiBlock
                size={30}
                color="red"
                className={styles.block_icon}
                onClick={() =>
                  setBlockedUserId((prevId) =>
                    prevId === item.id ? null : item.id
                  )
                }
              />
            </div>
          </div>
        ))}
    </div>
  );
};

export default BlockUserList;
